// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskContainer-module_task-detail___3Khf.TaskContainer-module_task-detail-height__lOB6C{height:50vh}.TaskContainer-module_task-detail___3Khf.TaskContainer-module_task-detail-submitting__vrNeE{opacity:.4}`, "",{"version":3,"sources":["webpack://./src/App/views/Task/containers/TaskContainer.module.scss"],"names":[],"mappings":"AAAA,wFAAgC,WAAW,CAAC,4FAAoC,UAAU","sourcesContent":[".task-detail.task-detail-height{height:50vh}.task-detail.task-detail-submitting{opacity:.4}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"task-detail": `TaskContainer-module_task-detail___3Khf`,
	"task-detail-height": `TaskContainer-module_task-detail-height__lOB6C`,
	"task-detail-submitting": `TaskContainer-module_task-detail-submitting__vrNeE`
};
export default ___CSS_LOADER_EXPORT___;
